import React from "react";
import { painPoints } from "../data/painPoints";
import { images } from "../data/images";
export function ProblemsSection() {
  return <section className="bg-cream-50 py-14 sm:py-28" data-id="element-224" data-mp="3gdxjsvmc9kjk">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-225" data-mp="31q499pc4187u">
        <div className="lg:sticky lg:top-24 lg:self-start" data-id="element-226" data-mp="36o5p81e8orf3">
          <h2 className="font-display text-4xl font-semibold leading-tight text-cocoa-900 sm:text-5xl" data-id="element-227" data-mp="36mkti8g6v2fn">
            Cocinar rico ya lo sabes. <em className="font-medium text-caramel-600" data-id="element-228" data-mp="2xnpr77g9mchm">Lo difícil es todo lo demás.</em>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-cocoa-700" data-id="element-229" data-mp="2ir8eocwcarth">
            Si alguna vez pensaste “podría vender esto”, pero te frenaste, seguramente te reconoces en alguna de estas situaciones.
          </p>
          <img src={images.brownies} alt="Brownies artesanales cortados en cuadrados" className="mt-10 hidden aspect-[4/5] w-full max-w-sm rounded-2xl object-cover lg:block" data-id="element-230" data-mp="gz3nj3mnzyjt" />
        </div>

        <ol className="divide-y divide-cocoa-900/10 border-y border-cocoa-900/10" data-id="element-231" data-mp="1i4lsz9n0n9uf">
          {painPoints.map((p, i) => <li key={p.title} className="grid grid-cols-[auto_1fr] gap-5 py-8 sm:gap-8" data-id="element-232" data-mp="1rw9opmqlvd1p" data-mpi={i}>
              <span className="font-display text-3xl italic text-caramel-500" aria-hidden="true" data-id="element-233" data-mp="1ry2l897i8gvz">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div data-id="element-234" data-mp="z8436xrq9k0t">
                <h3 className="text-xl font-semibold text-cocoa-900" data-id="element-235" data-mp="z9omfr8ldgjd">{p.title}</h3>
                <p className="mt-2 leading-relaxed text-cocoa-700" data-id="element-236" data-mp="ua297hsrk0ak">{p.text}</p>
              </div>
            </li>)}
          <li className="py-8" data-id="element-237" data-mp="185xm970heh61">
            <p className="font-display text-2xl leading-snug text-cocoa-900" data-id="element-238" data-mp="1465l3fdf3dap">
              No te falta talento. Te falta <span className="italic text-caramel-600" data-id="element-239" data-mp="2jmnwd180zt4x">un plan</span> que ordene cada paso.
            </p>
          </li>
        </ol>
      </div>
    </section>;
}